import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=9b3d2730&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b3d2730')) {
      api.createRecord('9b3d2730', component.options)
    } else {
      api.reload('9b3d2730', component.options)
    }
    module.hot.accept("./IconInfo.vue?vue&type=template&id=9b3d2730&", function () {
      api.rerender('9b3d2730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/IconInfo.vue"
export default component.exports